<template>
  <DialogBottomSheet
    data-qa="appointment_data_modal"
    v-bind="$attrs"
    :is-visible="isVisible"
    :content-class="contentClassProp"
    @dialog-bottom-sheet:change-visible="handleChangeVisible"
  >
    <template #activator="props">
      <slot
        name="activator"
        v-bind="props"
      />
    </template>
    <v-card
      data-qa="appointment_data_modal_body"
      class="d-flex flex-column"
      height="100%"
      :tile="isMobile"
    >
      <div class="d-flex align-center px-2 py-4 text--text">
        <span
          v-if="hasCloseIcon && !$attrs.persistent"
          v-ripple="isDisabled ? false : { center: true }"
          data-qa="appointment_data_modal_close_btn"
          class="ui-icon-close-not-a-circle rounded-circle mr-8 cursor-pointer"
          :class="{ 'disabled--text': isDisabled }"
          @click="isDisabled ? undefined : handleCloseModal()"
        />
        <span
          v-else-if="hasBackIcon"
          v-ripple="isDisabled ? false : { center: true }"
          data-qa="appointment_data_modal_back_btn"
          class="ui-icon-arrow-back rounded-circle mr-8 cursor-pointer"
          :class="{ 'disabled--text': isDisabled }"
          @click="isDisabled ? undefined : handleBackModal()"
        />
        <span
          data-qa="appointment_data_modal_title"
          class="text-h6"
        >{{ $i18next.t(title, options) }}</span>
      </div>
      <v-divider v-if="hasDivider" />
      <slot />
    </v-card>
  </DialogBottomSheet>
</template>

<script>
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'

export default {
  name: 'AppointmentDataModal',
  components: {
    DialogBottomSheet,
  },
  inheritAttrs: false,
  model: {
    prop: 'isVisible',
    event: 'appointment-data-modal:change-visible',
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    hasCloseIcon: {
      type: Boolean,
      default: false,
    },
    hasBackIcon: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
    hasDivider: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    isMobile: window.MOBILE_VERSION,
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    contentClassProp() {
      if (this.contentClass === '') {
        return this.isMobile
          ? 'appointment-data-modal-mobile'
          : 'appointment-data-modal-desktop'
      }

      return this.contentClass || ''
    },
    isDisabled() {
      return this.disabled
    },
  },
  methods: {
    handleChangeVisible(isVisible) {
      this.$emit('appointment-data-modal:change-visible', isVisible)
    },
    handleCloseModal() {
      this.handleChangeVisible(false)
    },
    handleBackModal() {
      this.$emit('appointment-data-modal:back')
    },
  },
}
</script>

<style lang="scss">
.appointment-data-modal-mobile {
  height: 65dvh;
  max-height: 100dvh !important;
}

.appointment-data-modal-mobile.v-dialog--fullscreen {
  height: 100dvh;
  bottom: 0;
  top: auto;
}

.appointment-data-modal-desktop {
  height: 496px;
}
</style>
